import { isFeatureEnabled } from 'owa-feature-flags';
import { MIN_LIST_VIEW_WIDTH, MIN_LIST_VIEW_WIDTH_PRIORITY_PIVOT } from '../internalConstants';

/**
 * Gets the minimum list view width based on feature flags
 * @returns the minimum width for the list view
 */
export function getMinListViewWidth(): number {
    return isFeatureEnabled('tri-priority-tab-dev2')
        ? MIN_LIST_VIEW_WIDTH_PRIORITY_PIVOT
        : MIN_LIST_VIEW_WIDTH;
}
